<template>
  <nav aria-label="Primary" class="border-b border-gray-300 bg-white" ref="nav">
    <div class="breakpoint-driven-widths">
    <div id="taia-chatbot" :data-customer-id="userStore.data?.customerId"  :data-dy-info="isDynamicYieldVariationData ? JSON.stringify(isDynamicYieldVariationData) : null" v-if="isEnableTaia"></div>
      <DesktopNavMenu 
        :nav-link-list="navLinks?.links"
        :user-initials="userStore.data?.initials"
        :user-authorities="userStore.data?.authorities.map((a) => a.authority)"
        :is-logged-in="userStore.loggedIn"
      />

      <MobileNavMenu 
        :nav-link-list="navLinks?.links"
        :user-name="userStore.data?.name"
        :is-logged-in="userStore.loggedIn"
      />
    </div>
  </nav>
</template>

<script setup lang="ts">
import DesktopNavMenu from "../molecule/desktopNavMenu.vue"
import MobileNavMenu from "../molecule/mobileNavMenu.vue"

interface BuilderTopNavLink {
  label: string;
  url: string;
}

interface BuilderNavLinkMegaMenuColumn {
  header: string;
  headerUrl?: string;
  links: BuilderTopNavLink[];
  type: "LINKS";
}

interface BuilderNavLinkMegaMenuFeatured {
  headline: string;
  imageUrl: string;
  imageAltText: string;
  description: {
    headline: string;
    copy: string;
  };
  callToAction?: {
    label: string;
    url: string;
  }
}

interface BuilderNavLinkMegaMenuOptions {
  enabled: boolean;
  columns: BuilderNavLinkMegaMenuColumn[];
  featured?: BuilderNavLinkMegaMenuFeatured;
}

export interface BuilderNavLink extends BuilderTopNavLink {
  tag?: string
  tagTextColor?: string
  tagBackgroundColor?: string
  megaMenuOptions?: BuilderNavLinkMegaMenuOptions
}

interface NavLinkData {
  links: BuilderNavLink[];
}

const dyStore = useDynamicYieldStore();
const dyNavChoice = dyStore.choices.find(choice => choice.name === 'Navigation - Mega Nav');
const dyNavVariation = dyNavChoice?.variations
  .map(variation => variation.data?.builderId)
  .find(builderId => !!builderId);

// fetch nav links
const model = "nav-links"
const route = useRoute()
const { data: navLinks } = await useAsyncData(() => builderIoService().fetchOneModel<NavLinkData>(model, route.path, true, {
  query: {
    ...(!!dyNavVariation ? { 
      $or: [
        { 'id': { $eq: dyNavVariation} },
        { 'name': { $eq: dyNavVariation} }
      ]
    } : {})
  },
}), {
  transform: (navLinks) => navLinks.data
});

// fetch stores
const localeStore = useLocaleStore()
const userStore = useUserStore()
const iframeStore = useIframeStore();
const { isEnableTaia, isDynamicYieldVariationData } = storeToRefs(iframeStore);

</script>
